import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import LoadingSpinner from '../Shared/LoadingSpinner/LoadingSpinner';
import { limeApiGet } from '../../utils/api';
import { loadPopulationPulseDashboard } from './loadDashboard';
import PopulationPulseView from './PopulationPulseView';
import { PopulationPulseDashboardResult } from './types';

function PopulationPulse(): React.ReactElement {
  const auth = useAuth();
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const [result, setResult] = useState<PopulationPulseDashboardResult | null>(null);

  useEffect(() => {
    if (!auth.user?.access_token) {
      return;
    }

    let cancelled = false;
    limeApiGet<{ enabled: boolean }>('population-pulse/access', auth)
      .then(access => {
        if (!cancelled) {
          setAllowed(!!access.enabled);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAllowed(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [auth, auth.user?.access_token]);

  useEffect(() => {
    if (allowed !== true) {
      return;
    }

    let cancelled = false;

    (async () => {
      const loaded = await loadPopulationPulseDashboard(auth);
      if (!cancelled) {
        setResult(loaded);
      }
    })().catch(() => {
      if (!cancelled) {
        setResult({
          status: 'error',
          message: 'Unable to load Population Pulse.',
        });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [allowed, auth, auth.user?.access_token]);

  if (allowed === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <LoadingSpinner loading={result == null}>
      {result ? <PopulationPulseView result={result} /> : <span>&nbsp;</span>}
    </LoadingSpinner>
  );
}

export default PopulationPulse;
